module.exports = __webpack_public_path__ + "static/media/dinesafe-app-welcome.5cd2f1e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/dinesafe-app-welcome.png
// module id = 113
// module chunks = 0